import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative w-full',
    menu: 'group',
    button:
      'disabled:text-inactive bg-bg-items-white text-icon-secondary flex size-6 items-center justify-center rounded-full p-0',
    closeIcon: 'size-5',
    input: ''
  },
  variants: {
    empty: {
      true: {
        button: 'pointer-events-none opacity-0'
      }
    }
  }
});
